import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Categoria } from 'src/app/model/categoria';
import { TokenStorageService } from 'src/app/services/api/TokenStorageService';
import { CategoriaService } from 'src/app/services/api/categoria.service';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
declare let $: any;
@Component({
  selector: 'app-categoria',
  templateUrl: './categoria.component.html',
  styleUrls: ['./categoria.component.css']
})
export class CategoriaComponent implements OnInit {
  @ViewChild('myModal')
  myModal!: ElementRef;
  formCategoria!: FormGroup;
  form = new FormData();
  url : string = `${environment.HOST}/api/media/`;
  urlServerUpload$ : string = `${environment.HOST}/api/media/`;
  urlimagen : string = `${environment.HOST}/api/media/`;
  nombreArchivo:String="";
  fileName:String="";
  previsualizacion:String="";
  esperar:boolean=false;
  tituloBotonGuardar:String="Nuevo Registro";
  fileExtension:String="";
  categoriadto:Categoria[]=[];
  errorForm:String[]=["0","0"];
  txtBuscar:string="";
  accion:number=0;
  idUsrDTO:number=0;
  nombreArchivoFull:String="";
  idCategoriaDTO:number=0;
  tipoMedia$ : String = "/1";
constructor(
  private sanitizer: DomSanitizer,
  private tokenStorage: TokenStorageService,
  private categoriaService:CategoriaService,
){


}







  ngOnInit(): void {
   
    this.formCategoria = new FormGroup({
      'txtDescripcion' : new FormControl('', Validators.required)
    });


    if (this.tokenStorage.getToken()!==null) {
      let json = JSON.stringify(this.tokenStorage.getUser());
       let data=JSON.parse(json.toString());
      
      this.idUsrDTO=data.idUsuario;
        }


this.OnGetCategoria();
  }



  OnGetCategoria(){
    this.categoriaService.getCategoria().subscribe(response =>{
      console.log(response)
      return this.categoriadto=response
    })
  }
  ValidarModificaRegistro(){
    let rs:number=0;
  
  
  
    if (this.previsualizacion!==""){
      this.errorForm[0]="0";
      rs= 0;
    }else {
      this.errorForm[0]="1";
      rs= 1;
    }
  
  
 
    if (this.formCategoria.value['txtDescripcion']!==""){
      this.errorForm[1]="0";
      rs= 0;
    }else {
      this.errorForm[1]="1";
      rs= 1;
    }
  
  
 


  
  
  
  
  return rs;
  
  }
  
  
  ValidarNuevoRegistro(){
  let rs:number=0;
  
  
  
    if (this.previsualizacion!==""){
      this.errorForm[0]="0";
      rs= 0;
    }else {
      this.errorForm[0]="1";
      rs= 1;
    }
  
  

  
    if (this.formCategoria.value['txtDescripcion']!==""){
      this.errorForm[1]="0";
      rs= 0;
    }else {
      this.errorForm[1]="1";
      rs= 1;
    }
  
  
  
  
    
  
  
  
  
    
  
    
  
  
  
  return rs;
  }








OnGuardarCategoria(){




  switch (this.accion) {
    case 0:
      if (this.ValidarNuevoRegistro()==0  ){
    
        this.esperar=true;
        this.categoriaService.nuevaCategoria(
          this.idUsrDTO,
        this.formCategoria.value['txtDescripcion'],
        this.fileName+'.'+ this.fileExtension).subscribe(response =>{
          console.log(response)
       if (response.toString()!="0"){
       
         if (this.previsualizacion!==null){
       
       
           this.OnGuardarImagen();
       
         }
        
       
       
        
       
         this.esperar=false;
    
    
       }else{
       
         if (response.toString()=="0"){
           this.esperar=false;
         }
       
       }
        
          
          
          alert("Categoria Registrada!!!");
          window.location.reload();
       
        
        })
      
      }
    break;
    
    case 1:
    
      if (this.ValidarModificaRegistro()==0  ){
    console.log(this.nombreArchivo)
    
    if (this.fileName==""){
    
      this.nombreArchivoFull="null";
    }else {
      this.nombreArchivoFull=this.nombreArchivo;
    }
   
    
    
    
    
        this.esperar=true;
    
        console.log("archivo:"+this.nombreArchivo);
    
   
    
    
          this.categoriaService.modificaCategoria(
          this.idCategoriaDTO,
          this.idUsrDTO,
        this.formCategoria.value['txtDescripcion'],
        this.nombreArchivoFull).subscribe(response =>{
          console.log(response)
       if (response.toString()!="0"){
       
         if (this.nombreArchivo!==""){
       
       
           this.OnGuardarImagen();
       
         }
        
        
       
        
    
         this.esperar=false;
    
       }else{
       
         if (response.toString()=="0"){
           this.esperar=false;
         }
       
       }
        
          
          
          alert("Categoría Modificada!!!");
          window.location.reload();
       
        
        })
      }
    break;
    }


}

onFileSelected(event:any){
  this.nombreArchivo="";
  const file:File = event.target.files[0] ;
 
   this.fileName =  uuid(); //get name from form for example
   this.fileExtension = file.name.split('?')[0].split('.').pop()+"";

  this.form.append("files",  event.target.files[0],this.fileName+'.'+ this.fileExtension);
 

this.nombreArchivo=this.fileName+'.'+ this.fileExtension;

this.blobFile(file).then((imagen : any)=>{
  this.previsualizacion=imagen.base;
  console.log(imagen);
})


}

blobFile = async ($event: any) => new Promise((resolve, reject): null | void => {
  try {
    const unsafeImg = window.URL.createObjectURL($event);
    const image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
    const reader = new FileReader();
    reader.readAsDataURL($event);
    reader.onload = () => {
      resolve({
        base: reader.result
      });
    };
    reader.onerror = error => {
      resolve({
        base: null
      });
    };

  } catch (e) {
    return null;
  }
})


OnGuardarImagen(){
  try{
    this.categoriaService.guardarImagen(this.form,1).subscribe(response=>{
      console.log("servidor:",response)
      })
  }catch(e){
  console.log("ERROR: ",e);
  }
  }
  


OnAbrirBusqueda(){

  $(this.myModal.nativeElement).modal('show'); 

}

OnSeleccionarCategoria(id:any){

  this.idCategoriaDTO=id;
 
  this.categoriaService.getCategoriaById( this.idCategoriaDTO).subscribe(response =>{
    for(let dato of response) {
     
      this.formCategoria.controls['txtDescripcion'].setValue(dato.descripcion);

      this.previsualizacion=this.urlimagen+dato.imagen+"/1";

      this.accion=1;
      this.tituloBotonGuardar="Modificar Registro";
    }
  });

  $(this.myModal.nativeElement).modal('hide'); 


}

OnBuscarPorDescripcion(){


}



}
